module.exports = __webpack_public_path__ + "static/media/ant_logo.04bcaecf.png";